export default "__VITE_ASSET__Bf19hwlo__"